import _classCallCheck from "/opt/build/repo/front-end/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/front-end/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var RequestSequencer = /*#__PURE__*/function () {
  function RequestSequencer() {
    _classCallCheck(this, RequestSequencer);
    this.requestSequence = 0;
    this.lastCompleted = 0;
  }
  _createClass(RequestSequencer, [{
    key: "next",
    value: function next() {
      return ++this.requestSequence;
    }
  }, {
    key: "isOldRequest",
    value: function isOldRequest(request) {
      return request < this.lastCompleted;
    }
  }, {
    key: "completed",
    value: function completed(request) {
      this.lastCompleted = request;
    }
  }]);
  return RequestSequencer;
}();
export { RequestSequencer as default };